export const mobilePhoneReg = /^1[0-9]{10}$/;
export const emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
// export const emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\\.){1,63}[a-z0-9]+$/;
export const verifyCodeReg = /\d{6}/ // 6位数字密码
export const passwordReg6 = /\d{6}/ // 6位数字密码

export const forbiddenAllBlankSpaceReg = /\S/ // 禁止全是空格
